import React from "react";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";

const getIconForStatus = (status) => {
    switch (status) {
        case "(Select All)":
            return "(Select All)";
        case "EndA":
            return <CheckOutlined className="checkOutLined" />;
        case "EndB":
            return <CheckOutlined className="checkOutLined" />;
        case null:
            return <CloseOutlined className="CloseOutlined" />;
        default:
            return "-";
    }
};


const logDataHelperFunctions = {
    getIconForStatus,
};

export { logDataHelperFunctions };